import {Component, h, Host, Prop} from '@stencil/core';

@Component({
  tag: 'teaser-title',
  shadow: false,
})

export class TeaserTitle {

  @Prop() align = 'left';

  @Prop() color = 'red';

  render() {
    return (
      <Host align={this.align} color={this.color} role="heading">
        <slot name="dateline"/>
        <slot/>
      </Host>
    );
  }
}
